import * as React from 'react';
import { useRecoilValue } from 'recoil';
import SortButton from './SortButton';
import useTooltip from '../hooks/useTooltip';
import { tableFilterAtomFamily } from '../CmdTableState';

interface IThOnlySort {
  id: string;
  title: string;
  tableName: string;
  isSortable: boolean;
  tooltip?: string;
  defaultTooltip?: string;
}

function ThOnlySort(props: IThOnlySort): JSX.Element {
  const tableActionsFilters = useRecoilValue(
    tableFilterAtomFamily({ [props.tableName]: props.id })
  );
  const { textRef, handleMouseEnter, handleMouseLeave } = useTooltip();

  return (
    <div
      className={`cmd-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        flex: 1,
        position: 'relative',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
      ref={textRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* {props.tooltip && (
        <CustomTooltip
          content={
            <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
              {`${props.title}: `}
              <strong>{props.tooltip}</strong>
            </div>
          }
          show={hover}
          position={tooltipPos}
        >
          <div id={props.id} className="text-cell" data-cy={`head-text-${props.id}`}>
            {props.title}
          </div>
        </CustomTooltip>
      )} */}
      {/* {!props.tooltip && ( */}
      <div
        id={props.id}
        title={props.tooltip || props.defaultTooltip}
        className="text-cell"
        data-cy={`head-text-${props.id}`}
      >
        {props.title}
      </div>
      {/* )} */}

      {props.isSortable && <SortButton id={props.id} tableName={props.tableName} />}
    </div>
  );
}

export default React.memo(ThOnlySort);
